/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, September 15th 2022, 2:54:47 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import create from "zustand";
import { IUserTaskTypesData } from "lib/schemas";

interface IWorkflowStore {
  taskTemplateFormOpenState: boolean;
  openTaskTemplateFormFn: () => void;
  closeTaskTemplateFormFn: () => void;
  isShowEdgeActions: { [edgeId: string]: boolean };
  showEdgeActions: (edgeId: string) => void;
  hideEdgeActions: (edgeId: string) => void;
  setUserTaskTypes: (userTaskTypes: IUserTaskTypesData) => void;
  userTaskTypes: IUserTaskTypesData;
}

export const useWorkflowStore = create<IWorkflowStore>((set) => {
  return {
    taskTemplateFormOpenState: false,
    openTaskTemplateFormFn: () => set((state) => ({ taskTemplateFormOpenState: true })),
    closeTaskTemplateFormFn: () => set((state) => ({ taskTemplateFormOpenState: false })),
    isShowEdgeActions: {},
    showEdgeActions: (edgeId) => set((state) => ({ isShowEdgeActions: { [edgeId]: true } })),
    hideEdgeActions: (edgeId) => set((state) => ({ isShowEdgeActions: { [edgeId]: false } })),
    userTaskTypes: {},
    setUserTaskTypes: (userTaskTypes) => set((state) => ({ userTaskTypes })),
  };
});

/** Selectors */
export const getUserTaskTypesData = (state: IWorkflowStore) => state.userTaskTypes;
